<template>
  <v-client-table
    :columns="columns"
    :data="facilitySchedules"
    :options="tableOptions"
    :id="tableName"
    :ref="tableName"
    :name="tableName"
  >
    <template slot="first_starting_hour" slot-scope="{ row }">
      <vue-timepicker
        auto-scroll
        manual-input
        :disabled="isDisabled"
        :class="{ 'empty' : !row.first_starting_hour}"
        format="HH:mm"
        :placeholder="!editable ? '-': 'HH:mm'"
        v-model="row.first_starting_hour"
        @input="changeTime($event, row, 'first_starting_hour')"
        :fixed-dropdown-button="!row.first_starting_hour && editable"
      >
        <template
          v-slot:dropdownButton
        >+</template>
        <template v-slot:clearButton>
          <span v-if="!row.first_starting_hour"></span>
        </template>
      </vue-timepicker>
    </template>
    <template slot="first_stopping_hour" slot-scope="{ row }">
      <vue-timepicker
        auto-scroll
        manual-input
        :disabled="isDisabled"
        :class="{ 'empty' : !row.first_stopping_hour }"
        format="HH:mm"
        :placeholder="!editable ? '-': 'HH:mm'"
        v-model="row.first_stopping_hour"
        @input="changeTime($event, row, 'first_stopping_hour')"
        :fixed-dropdown-button="!row.first_stopping_hour && editable"
      >
        <template
          v-slot:dropdownButton
        >+</template>
        <template v-slot:clearButton>
          <span v-if="!row.first_stopping_hour"></span>
        </template>
      </vue-timepicker>
    </template>
    <template slot="second_starting_hour" slot-scope="{ row }">
      <vue-timepicker
        auto-scroll
        manual-input
        :disabled="isDisabled"
        :class="{ 'empty' : !row.second_starting_hour }"
        v-model="row.second_starting_hour"
        format="HH:mm"
        :placeholder="!editable ? '-': 'HH:mm'"
        @input="changeTime($event, row, 'second_starting_hour')"
        :fixed-dropdown-button="!row.second_starting_hour && editable"
      >
        <template
          v-slot:dropdownButton
        >+</template>
        <template v-slot:clearButton>
          <span v-if="!row.second_starting_hour"></span>
        </template>
      </vue-timepicker>
    </template>
    <template slot="second_stopping_hour" slot-scope="{ row }">
      <vue-timepicker
        auto-scroll
        manual-input
        :disabled="isDisabled"
        :class="{ 'empty' : !row.second_stopping_hour }"
        format="HH:mm"
        :placeholder="!editable ? '-': 'HH:mm'"
        v-model="row.second_stopping_hour"
        @input="changeTime($event, row, 'second_stopping_hour')"
        :fixed-dropdown-button="!row.second_stopping_hour && editable"
      >
        <template
          v-slot:dropdownButton
        >+</template>
        <template v-slot:clearButton>
          <span v-if="!row.second_stopping_hour"></span>
        </template>
      </vue-timepicker>

    </template>
  </v-client-table>

</template>

<script>
import Vue from 'vue'
import { ClientTable } from 'vue-tables-2'
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import _ from 'lodash'

Vue.use(ClientTable, {}, false, 'bootstrap4')

export default {
  components:{
    VueTimepicker
  },
  props: {
    finallyId:{
      type: Number,
      required: true
    },
    schedules:{
      type: Array,
      default: () => []
    },
    editable:{
      type: Boolean,
      default: false,
    },

    tableName: {
      type: String,
      default: "scheduleTable"
    }
  },
  computed: {
    isDisabled: function () {
      return !this.editable
    },
    hasSchedules: function () {
      return !!this.schedules.length
    },
  },
  data: function () {
    const defaultDays = [
      this.$t('facility_schedules_table.monday'),
      this.$t('facility_schedules_table.tuesday'),
      this.$t('facility_schedules_table.wednesday'),
      this.$t('facility_schedules_table.thursday'),
      this.$t('facility_schedules_table.friday'),
      this.$t('facility_schedules_table.saturday'),
      this.$t('facility_schedules_table.sunday')
    ]
    const defaultSchedules = defaultDays.map(day => ({
      'facility_id': this.finallyId,
      day_nr: day,
      'first_starting_hour': '',
      'first_stopping_hour': '',
      'second_starting_hour': '',
      'second_stopping_hour': '',
    }))
    return {
      tableOptions:{
        sortable: [],
        filterable: false,
        headings: {
          'day_nr': this.$t('facility_schedules_table.day'),
          'first_starting_hour': this.$t('facility_schedules_table.one_starting_hour'),
          'first_stopping_hour': this.$t('facility_schedules_table.one_ending_hour'),
          'second_starting_hour': this.$t('facility_schedules_table.two_starting_hour'),
          'second_stopping_hour': this.$t('facility_schedules_table.two_ending_hour'),
        },
        skin: "table",
        childRow: function(h, row) {
          return <div></div>
        },
        showChildRowToggler: false,
        editableColumns: [
          'first_starting_hour', 'first_stopping_hour', 'second_starting_hour', 'second_stopping_hour'
        ]
      },
      columns: [
        'day_nr', 'first_starting_hour', 'first_stopping_hour', 'second_starting_hour', 'second_stopping_hour'
      ],
      facilitySchedules: defaultSchedules
    }
  },
  watch: {
    schedules: function(){
      this.modifySchedules()
    }
  },
  mounted: function () {
    this.modifySchedules()
    if (this.editable) {
      this.updateSchedules()
    }
    if(this.$refs[this.tableName]) {
      this.$refs[this.tableName].toggleChildRow();
    }
  },
  methods: {
    modifySchedules: function () {
      if (this.hasSchedules) {
        this.schedules.forEach(schedule => {
          const scheduleDayIndex = +schedule.day_nr - 1
          this.facilitySchedules[scheduleDayIndex].first_starting_hour = schedule.first_starting_hour || ''
          this.facilitySchedules[scheduleDayIndex].first_stopping_hour = schedule.first_stopping_hour || ''
          this.facilitySchedules[scheduleDayIndex].second_starting_hour = schedule.second_starting_hour || ''
          this.facilitySchedules[scheduleDayIndex].second_stopping_hour = schedule.second_stopping_hour || ''
        })
      }
    },
    changeTime: function (value, row, key) {
      if ( _.has( value, 'HH') && _.has( value, 'mm') ) {
        value = value.HH + value.mm
      }

      value = value || null

      const schedule = this.facilitySchedules.find(schedule => schedule.day_nr === row.day_nr)

      if (schedule) {
        schedule[key] = value
      }
    },
    updateSchedules: function () {
      this.$emit('update-schedules', { facilitySchedules: this.facilitySchedules })
    },
  }
}
</script>
<style lang="scss">
.VueTables--client{
  overflow-x: auto;
  .table-responsive, .table-responsive > table  {
    overflow: unset !important;
  }
  .table-responsive > table{
    border: 2px solid transparent;
    border-bottom: unset;
    border-top: unset;
    .VueTables__row{
      outline: 1px solid #C4C4C4;
      border-radius: 5px;
    }
    td{
      padding: 0.65rem;
      vertical-align: initial;
      white-space: nowrap;
      .vue__time-picker{
        .dropdown{
          width: 7em;
        }
        .dropdown .select-list, .vue__time-picker-dropdown .select-list{
          width: 7em;
        }
        > input{
          border-radius: 5px;
          text-align: center;

          &:disabled{
            border: none;
          }

          &.display-time{
            width: 7em;
            &:disabled, .disabled{
              color: #6E6E6E;
            }
          }

        }
        .controls{
          .clear-btn{
            color: #7DD7DA;
            .char{
              -webkit-margin-before: unset;
            }
          }
          .clear-btn, .dropdown-btn{
            padding: 0 0.5em;
          }
        }


        &.time-picker{
          width: max-content;
        }
        &.empty > input{
          border: 1px solid #A0A0A0;
          border-radius: 5px;
        }
        &:not(.empty){
          > input{
            background: #c9e4e5;
          }
        }
      }
    }
  }
}
</style>
